import {ModuleTopic} from '@cp/model';
import {env} from '../../config/env';

export default function mapTopicStringToModuleTopic(topicString: string): ModuleTopic {
  const [category, topic, detail] = topicString.split(env.topic.spacer).filter(Boolean);
  return {
    topic,
    category,
    detail,
  };
}
